var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalDeletIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.4142 28.4142L28.4142 51.4142M52.5858 51.4142L29.5858 28.4142M67.1631 67.5387H11.9161C10.9951 67.5387 10.2477 66.7912 10.2477 65.8703V22.7044C10.2477 21.7835 10.9951 21.036 11.9161 21.036C12.8371 21.036 13.5845 21.7835 13.5845 22.7044V64.2027H65.4946V22.5001C65.4946 21.5791 66.2421 20.8316 67.1631 20.8316C68.084 20.8316 68.8315 21.5791 68.8315 22.5001V65.8703C68.8315 66.7921 68.0849 67.5387 67.1631 67.5387ZM3.66985 29.8145C3.12761 29.8145 2.59621 29.5509 2.27587 29.0654C1.76867 28.2962 1.98056 27.2609 2.74971 26.7537L39.2785 2.6515C39.8449 2.27693 40.5807 2.28527 41.1396 2.66735L76.3537 26.7688C77.1136 27.2893 77.3089 28.3279 76.7883 29.0879C76.2677 29.8487 75.2308 30.0439 74.4692 29.5225L40.1803 6.05427L4.58749 29.5384C4.30386 29.7252 3.98519 29.8145 3.66985 29.8145Z",
    stroke: "#EFF0F4",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalDeletIcon);
export default __webpack_public_path__ + "static/media/hospital-delet-icon.ac40b172144715ecdee63c67ec9d6a12.svg";
export { ForwardRef as ReactComponent };